import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { tradeLicenseApi } from '../../services/tradeLicenseApi';
import ListPagination from '../../components/Office/ListPagination';

const PAGE_SIZE = 20;

const CounterPaymentCollection = () => {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({ count: 0, next: null, previous: null });

  const fetchApplications = useCallback(async () => {
    setLoading(true);
    try {
      const response = await tradeLicenseApi.getApplications({
        status: 'approved',
        payment_status: 'pending',
        page,
        page_size: PAGE_SIZE,
      });
      const data = response.data;
      setApplications(data.results || data || []);
      setPagination({
        count: data.count ?? (Array.isArray(data) ? data.length : 0),
        next: data.next ?? null,
        previous: data.previous ?? null,
      });
    } catch (error) {
      console.error('Failed to fetch payment collection applications:', error);
      setApplications([]);
      setPagination({ count: 0, next: null, previous: null });
    } finally {
      setLoading(false);
    }
  }, [page]);

  useEffect(() => {
    fetchApplications();
  }, [fetchApplications]);

  return (
    <div>
      <div className="counter-hero">
        <div>
          <h1>Counter Payment Collection</h1>
          <p>Collect fees only for applications that have completed final approval.</p>
        </div>
        <Link to="/office/applications/new" className="btn btn-primary">
          Create New Application
        </Link>
      </div>

      {loading ? (
        <div className="card" style={{ textAlign: 'center', padding: 40 }}>Loading payment queue...</div>
      ) : applications.length === 0 ? (
        <div className="card" style={{ textAlign: 'center', padding: 40 }}>
          <h3>No payment collection pending</h3>
          <p style={{ color: '#666', marginTop: 8 }}>Approved applications pending payment will appear here.</p>
        </div>
      ) : (
        <>
          <div className="collection-grid">
            {applications.map((app) => {
              const fee = Number(app.application_fee || 0);
              const paid = Number(app.paid_amount || 0);
              const pending = Number(app.pending_payment_amount || 0);
              const balance = Math.max(0, fee - paid - pending);

              return (
                <div key={app.id} className="collection-card">
                  <div className="collection-card-head">
                    <div>
                      <h3>{app.application_number}</h3>
                      <p>{app.business_name_en}</p>
                    </div>
                    <span className="status-badge status-approved">Approved</span>
                  </div>

                  <div className="collection-amounts">
                    <div><span>Total Fee</span><strong>₹{fee.toFixed(2)}</strong></div>
                    <div><span>Paid</span><strong>₹{paid.toFixed(2)}</strong></div>
                    <div><span>Pending Validation</span><strong>₹{pending.toFixed(2)}</strong></div>
                    <div className="balance"><span>Balance</span><strong>₹{balance.toFixed(2)}</strong></div>
                  </div>

                  <div className="collection-meta">
                    <span>{app.applicant_email || app.applicant_phone}</span>
                    <span>{app.current_stage_name || 'Approved'}</span>
                  </div>

                  <Link to={`/office/applications/${app.id}`} className="btn btn-success">
                    Collect Payment
                  </Link>
                </div>
              );
            })}
          </div>

          <ListPagination
            count={pagination.count}
            next={pagination.next}
            previous={pagination.previous}
            currentPage={page}
            pageSize={PAGE_SIZE}
            onPageChange={setPage}
            loading={loading}
          />
        </>
      )}
    </div>
  );
};

export default CounterPaymentCollection;
